import React, { useState } from 'react';
import { BurgerMenu } from '../../../global/icons/burgerMenu/BurgerMenu';
import { Drawer } from '../../../global/Drawer/Drawer';
import {
  BurgerMenuWrapper,
  MobileNavigationItemWrapper,
  MobileNavigationWrapper,
  NavigationDropdown,
} from './MobileNavigation.style';
import { MobileNavigationItem } from './MobileNavigationItem';
import { MobileAccount } from './MobileAccount';
import { NavBarItem } from '../navBar/navBarItem';
import { NavigationMenu } from './NavigationMenu';
import { NavigationDropdownItem } from './NavigationDropdownItem';

interface MobileNavigationProps {
  navbarItems: NavBarItem[];
  onClickNavigationItem: (navigationItemKey: string) => void;
}

export const MobileNavigation: React.FC<MobileNavigationProps> = ({
  navbarItems,
  onClickNavigationItem,
}) => {
  const [showNavigationDrawer, setShowNavigationDrawer] = useState(false);
  const handleCloseDrawer = () => {
    setShowNavigationDrawer(false);
  };

  const handleOpenDrawer = () => {
    setShowNavigationDrawer(true);
  };

  return (
    <>
      <BurgerMenuWrapper data-testid="burger-menu" onClick={handleOpenDrawer}>
        <BurgerMenu />
      </BurgerMenuWrapper>
      <Drawer visible={showNavigationDrawer} onCloseDrawer={handleCloseDrawer}>
        <MobileNavigationWrapper>
          <MobileAccount />
          {navbarItems.map((navbarItem) => {
            if (navbarItem.items?.length) {
              return (
                <NavigationMenu
                  key={navbarItem.key}
                  label={
                    <MobileNavigationItem
                      label={navbarItem.title}
                      link={navbarItem.customLink}
                      onClick={() => onClickNavigationItem(navbarItem.key)}
                    />
                  }
                  menuDropdown={
                    <NavigationDropdown>
                      {navbarItem.items.map((dropdownItem) => {
                        return (
                          <NavigationDropdownItem
                            key={dropdownItem.key}
                            label={dropdownItem.title}
                            link={dropdownItem.customLink}
                            onClick={() =>
                              onClickNavigationItem(dropdownItem.key)
                            }
                          />
                        );
                      })}
                    </NavigationDropdown>
                  }
                />
              );
            }
            return (
              <MobileNavigationItemWrapper
                key={navbarItem.key}
                data-test="mobile-nav-item"
              >
                <MobileNavigationItem
                  label={navbarItem.title}
                  link={navbarItem.customLink}
                  onClick={() => onClickNavigationItem(navbarItem.key)}
                />
              </MobileNavigationItemWrapper>
            );
          })}
        </MobileNavigationWrapper>
      </Drawer>
    </>
  );
};
